module.exports = __webpack_public_path__ + "img/1000.574478a7.svg";